<template>
  <div>
    <div class="container-fluid">
      <div class="back-home">
        <svg
          @click="back()"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="24"
          height="24"
        >
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            d="M7.828 11H20v2H7.828l5.364 5.364-1.414 1.414L4 12l7.778-7.778 1.414 1.414z"
            fill="rgba(50,152,219,1)"
          />
        </svg>
      </div>

      <div class="form-container">
        <form
          method="POST"
          class=" form py-4  col-lg-4 col-md-7  col-sm-9 col-11 mx-auto"
        >
          <h4 class="text-center my-2 form-heading">Welcome back</h4>

          <h5 class="text-center mb-2 form-heading">Login to continue</h5>

          <p
            class="errors col-lg-10 col-md-10 col-11 col-sm-10 mx-auto"
            id="error"
            v-show="NewError"
          ></p>

          <div class="form-group col-lg-10 mx-auto col-md-10 col-11 col-sm-10">
            <label class="form-labe" for="phoneCodes">Phone number</label>

            <br />

            <span class="f-small"
              >*First select the country phone code then fill the remaining
              numbers in the phone number box*</span
            >

            <select
              class="form-control"
              v-model="loginData.selector"
              @change="getCode()"
              name="phoneCodes"
              id="phoneCodes"
              required
            >
              <option
                v-for="phoneCode in phoneCodes"
                v-bind:value="phoneCode.code"
                :key="phoneCode.code"
              >
                {{ phoneCode.code }} --

                {{ phoneCode.name }}
              </option>
            </select>
          </div>

          <div class="input-group col-lg-10 col-md-10 col-11 col-sm-10 mx-auto">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">{{
                currentCode
              }}</span>
            </div>

            <input
              type="number"
              class="form-control"
              placeholder="Phone number"
              name="phone"
              id="phone"
              v-model="loginData.phone"
              autocomplete="autocomplete_off_hack_xfr4!k"
              aria-describedby="basic-addon1"
              required
            />
          </div>

          <div class="form-group lg-10 col-md-10 col-11 col-sm-10 mx-auto">
            <input
              v-if="showPassword"
              type="text"
              placeholder="Enter password "
              autocomplete="off"
              name="pwd"
              id="pwd"
              class="input form-control"
              v-model="loginData.password"
              required
            />

            <input
              v-else
              type="password"
              placeholder="Enter password"
              autocomplete="off"
              name="pwd"
              id="pwd"
              class="input form-control"
              v-model="loginData.password"
              required
            />

            <!-- <label class="form-label" for="pwd">Password</label> -->

            <svg
              class="pwd-icon"
              v-if="!showPassword"
              @click="toggleShow"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path fill="none" d="M0 0h24v24H0z" />

              <path
                d="M17.882 19.297A10.949 10.949 0 0 1 12 21c-5.392 0-9.878-3.88-10.819-9a10.982 10.982 0 0 1 3.34-6.066L1.392 2.808l1.415-1.415 19.799 19.8-1.415 1.414-3.31-3.31zM5.935 7.35A8.965 8.965 0 0 0 3.223 12a9.005 9.005 0 0 0 13.201 5.838l-2.028-2.028A4.5 4.5 0 0 1 8.19 9.604L5.935 7.35zm6.979 6.978l-3.242-3.242a2.5 2.5 0 0 0 3.241 3.241zm7.893 2.264l-1.431-1.43A8.935 8.935 0 0 0 20.777 12 9.005 9.005 0 0 0 9.552 5.338L7.974 3.76C9.221 3.27 10.58 3 12 3c5.392 0 9.878 3.88 10.819 9a10.947 10.947 0 0 1-2.012 4.592zm-9.084-9.084a4.5 4.5 0 0 1 4.769 4.769l-4.77-4.769z"
              />
            </svg>

            <!-- open eye -->

            <svg
              class="pwd-icon"
              v-if="showPassword"
              @click="toggleShow"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path fill="none" d="M0 0h24v24H0z" />

              <path
                d="M12 3c5.392 0 9.878 3.88 10.819 9-.94 5.12-5.427 9-10.819 9-5.392 0-9.878-3.88-10.819-9C2.121 6.88 6.608 3 12 3zm0 16a9.005 9.005 0 0 0 8.777-7 9.005 9.005 0 0 0-17.554 0A9.005 9.005 0 0 0 12 19zm0-2.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm0-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
              />
            </svg>
          </div>

          <div class="text-center">
            <button
              type="submit"
              @click.prevent="login()"
              class="btn btn_styles login btn-md btn-primary"
            >
              Login now
              <span
                v-if="hasSubmitted"
                class="spinner-border spinner-border-sm ml-2 my-auto"
              ></span>
            </button>
          </div>

          <div class="password-recap text-center forgotpwd">
            <a @click="forgot()" id="forgotpwd">Forgot password?</a>
          </div>

          <div class="signup text-center mx-auto my-2">
            <!-- <a href="./signUp.vue">Create an account</a> -->

            <router-link to="/signup">Create an account</router-link>
          </div>
        </form>
      </div>

      <div>
        <p class="text-center end">Powered by Zexos Group</p>
      </div>
    </div>
  </div>
</template>

<script>
const url = "https://bookinga.herokuapp.com/api/v1/client/login";
import axios from "axios";
import phoneCodes from "./phoneCodes.json";
import router from "./../../router/index";
import jwt_decode from "jwt-decode";
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};
export default {
  data() {
    return {
      currentCode: "+250",
      NewError: false,
      showPassword: false,
      UserCountryName: "",
      phoneCodes: phoneCodes.countries,
      loginData: { phone: "", password: "", selector: "+250" },
      hasSubmitted: false,
    };
  },
  created() {
  },
  computed: {
    getCode() {
      this.currentCode = this.loginData.selector;
    },
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  methods: {
    forgot() {
      router.push("/pwdrecovery");
    },
    back() {
      router.push("/");
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    setCompanyId(){
       axios
      .get("https://bookinga.herokuapp.com/api/v1/company/shaloi/getcomp", 
        config
      )
      .then((res) => {
        let companyId = res.data.data[0].id;
        localStorage.setItem("companyId",companyId)
      });
    },
    login() {
      if (this.loginData.password == "" || this.loginData.phone == "") {
        this.NewError = true;
        document.getElementById("error").innerHTML =
          "All the fields are required";
      } else if (
        this.loginData.password.length < 6 ||
        this.loginData.phone.length < 3 ||
        this.loginData.phone.length > 14
      ) {
        this.NewError = true;
        document.getElementById("error").innerHTML =
          "Invalid Phone number or password";
      } else {
        this.hasSubmitted = !this.hasSubmitted;
        axios
          .post(url, {
            Telephone: this.currentCode + this.loginData.phone,
            Password: this.loginData.password,
          })
          .then((response) => {
            if (response.data.success == true) {
              localStorage.setItem("jwt", response.data.token);
              const token = localStorage.getItem("jwt");
              const decoded = jwt_decode(token);
              const userRole = decoded.role;
              this.hasSubmitted = false;
              if (userRole == "shaloi") {
                this.setCompanyId();
                return router.push("/shaloi/dashboard");
              // } else if (userRole == "admin" && decoded.sign_in_account == 1) {
              //   return router.push("/admin/companyDetailsRegistration");
              } else if (userRole == "admin") {
                return router.push("/admin/dashboard");
              } else if (userRole == "developer") {
                return router.push("/developer/adminRegistration");
              } else if (userRole == "provider") {
                return router.push("/provider");
              } else {
                return router.push("/dashboard/bus");
              }
            }else {
              this.hasSubmitted = false;
              this.NewError = true;
              this.hasSubmitted = !this.hasSubmitted;
              return (document.getElementById("error").innerHTML =
                response.data.message);
            }
          })
          .catch((error) => {
            this.NewError = true;
            this.hasSubmitted = false;
            document.getElementById("error").innerHTML =
              error.response.data.message;
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.password-recap {
  float: inherit;
}

a {
  color: $mainBlue !important;
  font-size: 0.9em;
}
.back-home > svg {
  cursor: pointer;
}
</style>
